<template>
    <div class="not_fund">
        404 页面找不到
    </div>
</template>
<script>
export default {
    name:'not_fund'
}
</script>
